module.exports = __webpack_public_path__ + "static/media/extranaDama_01.42718852.jpg";